/**
 * @generated SignedSource<<f7578885d7f884c47c71e3c2413bb091>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSidebarBuyerIncentives_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpBuyerIncentivesModal_user">;
  readonly " $fragmentType": "PdpSharedSidebarBuyerIncentives_user";
};
export type PdpSharedSidebarBuyerIncentives_user$key = {
  readonly " $data"?: PdpSharedSidebarBuyerIncentives_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSidebarBuyerIncentives_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarBuyerIncentives_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpBuyerIncentivesModal_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c785051f2705c0c8e4ff464fb759e81a";

export default node;
